import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';
import { shouldForwardProp } from '@/utils/style.utils';
import { css } from '@emotion/react';

const FareFamiliesWrapper = styled('div', { shouldForwardProp })`
  display: flex;
  gap: 16px;
`;

const getIconColor = (isDisabled: boolean, $isFlightDetails?: boolean) => {
  if ($isFlightDetails) {
    return isDisabled ? color(COLOR_VARIANTS.OVERLAY) : color(COLOR_VARIANTS.WHITE);
  }
  return isDisabled ? color(COLOR_VARIANTS.GAINSBORO) : color(COLOR_VARIANTS.AQUA100);
};

const FareFamilySlider = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

const ArrowButton = styled('div', { shouldForwardProp })<{
  $isDisabled?: boolean;
  $isFlightDetails?: boolean;
}>`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  justify-content: center;

  ${({ $isFlightDetails, $isDisabled }) => {
    if ($isFlightDetails) {
      return css`
        background-color: ${color(COLOR_VARIANTS.OVERLAY)};
      `;
    }
    return css`
      border: 1px solid ${getIconColor($isDisabled)};
    `;
  }}

  svg {
    color: ${({ $isDisabled, $isFlightDetails }) => getIconColor($isDisabled, $isFlightDetails)};
    stroke: ${({ $isDisabled, $isFlightDetails }) => getIconColor($isDisabled, $isFlightDetails)};
    stroke-width: 1;
  }
`;

const FareFamiliesTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
`;

const Wrapper = styled.div`
  padding: 16px 0 16px 16px;
  width: 100%;
`;

export default {
  FareFamiliesWrapper,
  FareFamilySlider,
  ArrowButton,
  FareFamiliesTitle,
  Wrapper,
};
